// extracted by mini-css-extract-plugin
export default {"selectWrapper":"TemplateSettings_selectWrapper__PxdI1","templateSettingsForm":"TemplateSettings_templateSettingsForm__BKrWP"};